import { Radio } from '@base-ui/react/radio'
import { RadioGroup as BRadioGroup } from '@base-ui/react/radio-group'
import clsx from 'clsx'

export interface RadioOption {
  value: string
  label: string
}

export interface RadioGroupProps {
  name: string
  value?: string | null
  defaultValue?: string
  onChange?: (value: string) => void
  options: RadioOption[]
  disabled?: boolean
  required?: boolean
  direction?: 'horizontal' | 'vertical'
  className?: string
}

export function RadioGroup({
  name,
  value,
  defaultValue,
  onChange,
  options,
  disabled,
  required,
  direction = 'horizontal',
  className,
}: RadioGroupProps) {
  return (
    <BRadioGroup
      name={name}
      value={value}
      defaultValue={defaultValue}
      onValueChange={(val) => onChange?.(val as string)}
      disabled={disabled}
      required={required}
      className={clsx(direction === 'vertical' ? 'space-y-2' : 'flex gap-4', className)}
    >
      {options.map((option) => (
        // biome-ignore lint/a11y/noLabelWithoutControl: Radio.Root acts as the form control - https://base-ui.com/react/components/radio
        <label
          key={option.value}
          data-testid={option.value}
          className="flex items-center gap-2 cursor-pointer"
        >
          <Radio.Root
            value={option.value}
            className={clsx(
              // Base styles
              'w-4 h-4 transition-all cursor-pointer shrink-0',
              'border-2 border-gray-stroke bg-white rounded-full',
              'focus:outline-none focus:ring-2 focus:ring-lavender focus:ring-offset-2',
              // Checked state
              'data-[checked]:border-forest data-[checked]:border-[6px]',
              // Disabled state
              'disabled:opacity-50 disabled:cursor-not-allowed'
            )}
          >
            <Radio.Indicator />
          </Radio.Root>
          <span className="text-charcoal-75 text-base select-none">{option.label}</span>
        </label>
      ))}
    </BRadioGroup>
  )
}
